import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const endPoint = process.env.REACT_APP_API_BASE_URL;

export default function QRAttendanceLoginPage() {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("qr_token");
    const role = localStorage.getItem("qr_role");

    if (token && role) {
      if (role === "ADMIN") {
        navigate("/qr-attendance-list");
      } else {
        navigate("/QrScanner");
      }
    }

    inputRef.current?.focus();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setStatus("⏳ Logging in...");
    setLoading(true);

    try {
      const res = await axios.post(
        `${endPoint}/api/attendance/login`,
        formData
      );

      // Save data in localStorage
      localStorage.setItem("qr_token", res.data.token);
      localStorage.setItem("qr_token_expiry", res.data.expiresAt);
      localStorage.setItem("qr_role", res.data.role);
      localStorage.setItem("qr_user_name", res.data.userName);

      setStatus("✅ Login successful! Redirecting...");

      // Redirect based on role
      setTimeout(() => {
        if (res.data.role === "ADMIN") {
          navigate("/qr-attendance-list");
        } else {
          navigate("/QrScanner");
        }
      }, 1000);
    } catch (err) {
      setStatus(err.response?.data || "❌ Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#f9fafb",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial, sans-serif",
        padding: "16px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          background: "#fff",
          borderRadius: "16px",
          padding: "36px 28px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "30px",
            color: "#2c3e50",
            fontSize: "26px",
            fontWeight: "bold",
          }}
        >
          QR Attendance Login
        </h2>

        <form
          onSubmit={handleLogin}
          style={{ display: "flex", flexDirection: "column", gap: "20px" }}
        >
          <input
            ref={inputRef}
            type="text"
            name="username"
            value={formData.username}
            onChange={(e) =>
              setFormData({ ...formData, username: e.target.value })
            }
            placeholder="Username"
            style={{
              border: "1px solid #dcdfe3",
              borderRadius: "12px",
              padding: "18px",
              fontSize: "20px",
              outline: "none",
              transition: "0.2s",
            }}
            required
            onFocus={(e) => {
              e.target.style.border = "2px solid #2ecc71";
            }}
            onBlur={(e) => {
              e.target.style.border = "1px solid #dcdfe3";
            }}
          />

          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            placeholder="Password"
            style={{
              border: "1px solid #dcdfe3",
              borderRadius: "12px",
              padding: "18px",
              fontSize: "20px",
              outline: "none",
              transition: "0.2s",
            }}
            required
            onFocus={(e) => {
              e.target.style.border = "2px solid #2ecc71";
            }}
            onBlur={(e) => {
              e.target.style.border = "1px solid #dcdfe3";
            }}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              background: loading ? "#95a5a6" : "#2ecc71",
              border: "none",
              borderRadius: "12px",
              padding: "18px",
              color: "#fff",
              fontWeight: "bold",
              cursor: loading ? "not-allowed" : "pointer",
              fontSize: "22px",
              transition: "0.2s",
            }}
          >
            {loading ? "⏳ Logging in..." : "Login"}
          </button>
        </form>

        {status && (
          <div
            style={{
              marginTop: "20px",
              background: status.includes("✅") ? "#eafaf1" : "#fdecea",
              color: status.includes("✅") ? "#27ae60" : "#c0392b",
              borderRadius: "10px",
              padding: "16px",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "18px",
              border: `2px solid ${
                status.includes("✅") ? "#2ecc71" : "#e74c3c"
              }`,
            }}
          >
            {status}
          </div>
        )}
      </div>
    </div>
  );
}
